import { IconActionMap16, IconActionTable16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, useCallback, useState } from 'react';

import { ChipsOption } from 'shared/models/ChipsOption';
import { PikProjectsChipsDataService } from 'shared/services/ChipsDataService';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { PikProjects } from './PikProjects';
import { type IPikProjectsItemViewModel, PikProjectsItemViewModel } from './external/models/PikProjectsItemViewModel';
import { trackPikProjectsFilterChange } from './internal/tracking/trackPikProjectsFilterChange';
import { trackPikProjectsViewMode } from './internal/tracking/trackPikProjectsViewMode';
import { trackShowPikProjectsSection } from './internal/tracking/trackShowPikProjectsSection';

const pikProjectsChipsDataService = new PikProjectsChipsDataService([
  new PikProjectsItemViewModel(new ChipsOption('Плитками', undefined, <IconActionTable16 />), 'list'),
  new PikProjectsItemViewModel(new ChipsOption('На карте', undefined, <IconActionMap16 />), 'map'),
]);

export const PikProjectsContainer: FC = () => {
  const { logger } = useApplicationContext();

  const [activePikProjectsItem, setActivePikProjectsItem] = useState<IPikProjectsItemViewModel>(
    pikProjectsChipsDataService.defaultItem,
  );

  const handleChange = useCallback<(value: string[]) => void>(
    value => {
      const next = pikProjectsChipsDataService.getActiveItem(value[0], logger);

      trackPikProjectsViewMode(next);
      setActivePikProjectsItem(next);
    },
    [logger],
  );

  const handleView = useCallback(() => trackShowPikProjectsSection(), []);

  const handleFilterChange = useCallback((field: string, value: string) => {
    trackPikProjectsFilterChange(field, value);
  }, []);

  return (
    <PikProjects
      activePikProjectsItem={activePikProjectsItem}
      chipsOptions={pikProjectsChipsDataService.chipsOptions}
      onChange={handleChange}
      onFilterChange={handleFilterChange}
      onView={handleView}
    />
  );
};
